import { z } from "zod";

const envSchema = z.object({
  VITE_APP_ENV: z.enum(["local", "dev", "stg", "prd"]),
  VITE_API_URL: z.string(),
  VITE_API_URL_DATA_EXTRACTOR: z.string(),
});

export type Env = z.infer<typeof envSchema>;

export function checkEnv(runtimeEnv: Record<string, string | undefined>): Env {
  const cleanedEnv = Object.entries(runtimeEnv).reduce(
    (acc, [key, value]) => {
      acc[key] = value === "" ? undefined : value;
      return acc;
    },
    {} as Record<string, string | undefined>,
  );

  try {
    return envSchema.parse(cleanedEnv);
  } catch (error) {
    if (error instanceof z.ZodError) {
      console.error("❌ Environment validation failed");
      console.error(error.issues);
      throw new Error("Environment validation failed");
    }
    throw error;
  }
}

let _env: Env | undefined;

function getEnv(): Env {
  if (!_env) {
    _env = envSchema.parse(import.meta.env);
  }
  return _env;
}

export const env = new Proxy({} as Env, {
  get(_, prop: keyof Env) {
    return getEnv()[prop];
  },
});
